import Card from "components/card";
import { MdOpenInNew } from "react-icons/md";
import { NEWS_STATIC_DATA } from "utils/staticData/newsSD";
import useTranslation from "utils/hooks/useTranslation";
const General = () => {
  const { translation } = useTranslation();

  const renderOptions = () => {
    const optionsItems = NEWS_STATIC_DATA.quick_access.options.map(
      (g, index) => (
        <div
          key={"optionGeneral" + index}
          className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
        >
          <p className="text-sm text-gray-600">{g.title}</p>
          <p className="mt-2 text-base font-medium text-navy-700 dark:text-white">
            {g.description}
          </p>
          <div className="flex w-full items-center justify-end rounded-t-3xl">
            <a
              href={g.link}
              target="blank"
              className="flex items-center justify-end text-branded-900 hover:text-brand-300"
            >
              <MdOpenInNew className="h-5 w-5" />
            </a>
          </div>
        </div>
      )
    );
    return <>{optionsItems}</>;
  };

  return (
    <Card extra={"w-full h-full p-3"}>
      {/* Header */}
      <div className="mb-2 mt-2 w-full">
        <h4 className="px-2 text-base font-bold text-navy-700 dark:text-white">
          {translation.newsQuickAccessTitle}
        </h4>
        <p className="mt-2 px-2 text-xs text-gray-600">
          {translation.newsQuickAccessSubTitle}
        </p>
      </div>
      {/* Cards */}
      <div className="grid grid-cols-2 gap-4 px-2">{renderOptions()}</div>
    </Card>
  );
};

export default General;
